import { privateFetch, publicFetch } from "../../libs/axios"
import {
  GetOrderDetailsResponseType,
  UpdateQuantityOfOrderItemRequestType,
} from "../../types/OrderTypes"

import {
  GetOrderParticipantsResponseType,
  ICancelGiftCardRefundRequestType,
  ICancelGiftCardRefundResponseType,
} from "./types"

export const cancelGiftCardRefund = async ({
  orderId,
  transactionId,
  reason,
}: ICancelGiftCardRefundRequestType) =>
  await privateFetch().post<ICancelGiftCardRefundResponseType>(
    `/api/v1/order/${orderId}/refund/${transactionId}/cancel-gift-card`,
    { reason }
  )

export const updateProductOfOrderItem = async (
  orderId: string,
  orderItemId: string,
  body: UpdateQuantityOfOrderItemRequestType
) =>
  await privateFetch().post<GetOrderDetailsResponseType>(
    `/api/v1/order/${orderId}/order-item/${orderItemId}/change-product`,
    body
  )

export const getOrderParticipants = async (orderId: string, isIntegratedPage?: boolean) => {
  if (isIntegratedPage) {
    return await publicFetch().get<GetOrderParticipantsResponseType>(
      `/api/v1/public/order/${orderId}/participants`
    )
  }
  return await privateFetch().get<GetOrderParticipantsResponseType>(
    `/api/v1/order/${orderId}/participants`
  )
}
